import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const ZoomOutIcon = ({ color = '#fff', size = '20', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={size}
    {...props}
  >
    <path
      fill={color}
      d="M19.7 18.2L16 14.5C17.2 13 17.9 11 17.9 9c0-4.9-4-9-9-9S0 4 0 9c0 4.9 4 9 9 9 2.1 0 4-.7 5.5-1.9l3.7 3.7c.2.2.5.3.8.3.3 0 .5-.1.8-.3.3-.5.3-1.2-.1-1.6zM9 15.8c-3.8 0-6.8-3.1-6.8-6.8 0-3.8 3.1-6.8 6.8-6.8 3.8 0 6.8 3.1 6.8 6.8 0 3.7-3.1 6.8-6.8 6.8z"
    />
    <path
      fill={color}
      d="M11.9 8H6c-.5 0-1 .4-1 1s.5.9 1 .9h6c.5 0 .9-.4.9-.9s-.4-1-1-1z"
    />
  </svg>
);

ZoomOutIcon.propTypes = propTypes;

export default ZoomOutIcon;
